import isEmpty from 'lodash/isEmpty'

import { getCookie, setCookie } from '@core/helpers/cookies'
import localStorage, { canUseLocalStorage } from '@core/helpers/localStorage'

export const canSetToLocalStorage = () => {
  // eslint-disable-next-line import/no-named-as-default-member
  if (!canUseLocalStorage()) {
    return false
  }
  let isAvailable = true

  try {
    localStorage.setItem('space-check-test-key', 'an-acceptably-small-value')
    localStorage.removeItem('space-check-test-key')
  } catch (e) {
    isAvailable = false
  }

  return isAvailable
}

export default {
  setItem: (key, value) => {
    try {
      if (canSetToLocalStorage()) {
        localStorage.setItem(key, value)
      } else {
        setCookie(key, value)
      }
    } catch {
      // fails silently
    }
  },
  getItem: (key) => {
    try {
      if (canUseLocalStorage()) {
        return localStorage.getItem(key)
      }

      const result = getCookie(key, document.cookie)
      if (result === undefined) {
        return null
      }

      return result
    } catch {
      // fails silently
    }

    return null
  },
  removeItem: (key) => {
    try {
      if (canUseLocalStorage()) {
        return localStorage.removeItem(key)
      }
      const expires = new Date()
      // Make it expire yesterday
      expires.setTime(expires.getTime() + -1 * 24 * 60 * 60 * 1000)

      return setCookie(key, '', { expires: expires.toGMTString() })
    } catch {
      // fails silently
    }

    return null
  },
  hasKey: (key) => {
    try {
      if (canUseLocalStorage()) {
        return !isEmpty(localStorage.getItem(key))
      }

      return !isEmpty(getCookie(key, document.cookie))
    } catch {
      // fails silently
    }

    return null
  },
}
